import { render, staticRenderFns } from "./DisasterInformation.vue?vue&type=template&id=a00708f4&scoped=true"
import script from "./DisasterInformation.vue?vue&type=script&lang=js"
export * from "./DisasterInformation.vue?vue&type=script&lang=js"
import style0 from "./DisasterInformation.vue?vue&type=style&index=0&id=a00708f4&prod&scoped=true&lang=css"
import style1 from "./DisasterInformation.vue?vue&type=style&index=1&id=a00708f4&prod&lang=css"
import style2 from "./DisasterInformation.vue?vue&type=style&index=2&id=a00708f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00708f4",
  null
  
)

export default component.exports